import { FC, ReactNode, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';

import { Icon, Modal } from 'cosmos-components';

import { colors } from 'src/themes';
import * as S from 'src/components/shared/SciPage/SciPage.style';
import { sciLanguageSelector } from 'src/components/shared/SciPage/SciPage.selector';
import { getLangCode } from 'src/utils/string';

export const redirectErrorModalTestId = 'redirect-error-modal';
export const redirectErrorButtonTestId = 'redirect-error-button';

export interface RedirectErrorModalProps {
    title: ReactNode;
    description: ReactNode;
    buttonLabel: ReactNode;
    redirectPath: string;
    onClose?: () => void;
    testIdSuffix?: string;
}

export const RedirectErrorModal: FC<RedirectErrorModalProps> = ({
    title,
    description,
    buttonLabel,
    redirectPath,
    onClose,
    testIdSuffix,
}) => {
    const navigate = useNavigate();
    const lng = getLangCode(useSelector(sciLanguageSelector));

    const suffix = testIdSuffix ? `-${testIdSuffix}` : '';

    const goToRedirect = useCallback(() => {
        onClose?.();
        navigate({
            pathname: redirectPath,
            search: createSearchParams(lng ? { lng } : {}).toString(),
        });
    }, [navigate, lng, onClose, redirectPath]);

    return (
        <S.Container>
            <Modal
                data-test-id={`${redirectErrorModalTestId}${suffix}`}
                visible
                closable={false}
                maskStyle={{
                    backgroundColor: `${colors.lightBlack} !important`,
                    opacity: '50% !important',
                }}
            >
                <Icon
                    color="secondaryOrange"
                    size="large"
                    key="warning"
                    name="warning"
                />
                <S.StyledHeader>{title}</S.StyledHeader>
                <S.StyledParagraph>{description}</S.StyledParagraph>
                <S.StyledPrimaryButton
                    data-test-id={`${redirectErrorButtonTestId}${suffix}`}
                    onClick={goToRedirect}
                >
                    {buttonLabel}
                </S.StyledPrimaryButton>
            </Modal>
        </S.Container>
    );
};
